module.exports = __webpack_public_path__ + "img/menu_icon.d04ce38a.png";